import { gtag } from "ga-gtag";
export const isLocalhost = window.location.hostname === "localhost";
export const needsGoogleAnalytics = !isLocalhost;
export function tagEvent(event: string, extra?: any): void {
  if (!needsGoogleAnalytics) return;
  gtag("event", event, extra || {});
}
